import { render, staticRenderFns } from "./shareholderStructure.vue?vue&type=template&id=6b4d8ba1&scoped=true"
import script from "./shareholderStructure.vue?vue&type=script&lang=js"
export * from "./shareholderStructure.vue?vue&type=script&lang=js"
import style0 from "./shareholderStructure.vue?vue&type=style&index=0&id=6b4d8ba1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b4d8ba1",
  null
  
)

export default component.exports